import { useEffect } from 'react';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

const TOKEN = import.meta.env.REACT_APP_LOGROCKET_TOKEN;

export const useLogRocket = (isEnabled: boolean, verificationId: string) => {
    useEffect(() => {
        if (isEnabled && TOKEN && verificationId) {
            LogRocket.init(TOKEN);
            setupLogRocketReact(LogRocket);
            LogRocket.identify(verificationId);
        }
    }, [isEnabled, verificationId]);
};
